<template>
  <EasyDataTable
    :headers="reportFields"
    :items="reports"
    :alternating="true"
    :rows-per-page="10000"
    :hide-rows-per-page="true"
  >
    <template #item-languages="item">
      <span v-for="content in item.translations" :key="content.countryCode">
        <span :class="'flagItem flag-icon flag-icon-' + content.countryCode"></span>
      </span>
    </template>
    <template #item-buttons="item">
      <b-button
                @click.stop="$emit('beforeEditReport', item)"
                size="sm"
                class="fa fa-edit"
                v-if="allowEdit">
      </b-button>
    </template>
  </EasyDataTable>
</template>

<script>
export default {
  name: 'expert-reports-table',
  props: {
    reports: [],
    allowEdit: false
  },
  computed: {
    reportFields() {
      var fields = [
        {
          value: 'name',
          text: this.$t('privatePage.expert_report_name_header'),
          sortable: true
        },
        {
          value: 'testMethodName',
          text: this.$t('privatePage.testmethod_header'),
          sortable: true
        },
        { value: 'languages', text: this.$t('lang') }
      ]

      if (this.allowEdit) {
        fields.push({
          value: 'buttons',
          text: ' ',
          tdClass: 'rightAlignedField'
        })
      }

      return fields
    }
  },
  created() {
    console.log('reports : ', this.reports)
  }
}
</script>

<style scoped>
.flagItem {
  margin-right: 2px;
}
</style>
